import React, { PureComponent } from 'react';
import { Button } from 'semantic-ui-react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ZoomIn from '../assets/zoom_in';
import Const from '../../config/const';
import * as classes from './classes.module.scss';

const roundSize = (v) => parseFloat(v.toFixed(2));

const DEFAULT_DPI = 12;

export default class CustomImage extends PureComponent {
  static propTypes = {
    closePanel: PropTypes.func.isRequired,
    addCustomImage: PropTypes.func.isRequired,
    removeCustomImage: PropTypes.func.isRequired,
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    widthIn: PropTypes.number,
    heightIn: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.loadImageProps(props, false);
  }

  componentDidUpdate(prevProps) {
    const { src } = this.props;
    const { src: sSrc } = this.state;
    if (prevProps.src !== src && src !== sSrc) {
      this.loadImageProps(this.props, true);
    }
  }

  closePanel = () => {
    const { closePanel } = this.props;
    closePanel(Const.panelKinds.other);
  }

  loadImage = (src, binaryContent) => {
    const i = new Image();
    i.onload = () => {
      const { width, height } = i;
      const widthIn = roundSize(width / DEFAULT_DPI);
      const heightIn = roundSize(height / DEFAULT_DPI);
      const ratio = widthIn / heightIn;
      this.setState({
        src, widthIn, heightIn, ratio, binaryContent
      });
    };
    i.src = src;
  };

  onFileSelected = (e) => {
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.addEventListener('load', () => {
      this.loadImage(reader.result, file);
    }, false);
    reader.readAsDataURL(file);
  }

  onChangeWidth = (e) => {
    const { ratio } = this.state;
    const widthIn = parseFloat(e.target.value);
    const heightIn = roundSize(widthIn / ratio);
    this.setState({ widthIn, heightIn });
  }

  onChangeHeight = (e) => {
    const { ratio } = this.state;
    const heightIn = parseFloat(e.target.value);
    const widthIn = roundSize(ratio * heightIn);
    this.setState({ widthIn, heightIn });
  }

  setCustomImage = () => {
    const { addCustomImage } = this.props;
    const {
      src, widthIn, heightIn, binaryContent
    } = this.state;
    addCustomImage({
      src, widthIn, heightIn, binaryContent
    });
    this.closePanel();
  };

  removeCustomImage = () => {
    const { removeCustomImage } = this.props;
    removeCustomImage();
    this.setState({
      src: null, widthIn: 0, heightIn: 0, ratio: 0
    });
    this.closePanel();
  };

  loadImageProps(props, canSetState) {
    const { src, widthIn, heightIn } = props;
    const newState = {
      src,
      widthIn,
      heightIn,
      ratio: (widthIn && heightIn) ? widthIn / heightIn : 0
    };
    if (canSetState) {
      this.setState(newState);
    } else {
      this.state = newState;
    }
  }

  renderInputs() {
    const { widthIn, heightIn } = this.state;
    if (!widthIn) {
      return (
        <div className={ classnames(classes.description, classes.selectFile) }>
          <p>
            Upload a custom image.
          </p>
        </div>
      );
    }

    return (
      <div className={ classes.description }>
        <p>
          Please define the exact size of the image
          <br />
          in inches in order to best represent the size of your background.
        </p>
        <div>
          <label htmlFor="customWidth">
            Width (inches)
            <input
              type="number"
              value={ widthIn }
              onChange={ this.onChangeWidth }
              className={ classes.input }
              name="customWidth"
              id="customWidth"
            />
          </label>
          <label htmlFor="customHeight">
            Height (inches)
            <input
              type="number"
              value={ heightIn }
              onChange={ this.onChangeHeight }
              className={ classes.input }
              name="customHeight"
              id="customHeight"
            />
          </label>
        </div>
        <div>
          <Button onClick={ this.setCustomImage }>Save</Button>
          <Button onClick={ this.removeCustomImage }>Remove</Button>
        </div>
      </div>
    );
  }

  renderImage() {
    const { src } = this.state;
    return src ? (
      <img src={ src } alt="img" />
    ) : (
      <div className={ classes.uploadHolder }>
        <label htmlFor="customFile" className={ classes.upload }>
          UPLOAD IMAGE
          <ZoomIn fill="#000" />
          <input
            accept="image/png, image/jpeg"
            type="file"
            onChange={ this.onFileSelected }
            name="customFile"
            id="customFile"
          />
        </label>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className={ classes.holder }>
          <div className={ classes.imageContainer }>
            { this.renderImage() }
          </div>
          { this.renderInputs() }
        </div>
      </div>
    );
  }
}
